export default {"src":"/_next/static/media/clock.b14acaf8.svg","height":20,"width":21,"blurWidth":0,"blurHeight":0};